import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { LoadingPage } from '../LoadingPage'
import { ErrorPage } from "../ErrorPage"
import { PersonalDocumentSlider } from './slider'
import { Button } from '../../components';
import * as S from './styles';

export const PersonalDocumentConfirmationBatch = (props) => {

    const { clientThemeSettings, signBatchData, setSignerBatchStep, setSignBatchData } = props
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(false)
    const initialError = {
        "has_error": false,
        "status": 0
    }

    const onSubmit = () => {
        const data = {
            "event_date": new Date().toISOString(),
            "step": "personal_document"
        }
        const config = {
            headers:
            {
                'Authorization': signBatchData.signer_token
            }
        }
        setLoading(true)
        axios.patch('/signer_batch', data, config)

            .then(response => {
                setSignerBatchStep(response.data.next_step)
                setSignBatchData({ ...signBatchData, ...response.data })
            })
            .catch((error) => {
                if ([401, 403, 409].includes(error.response?.status)) {
                    setError({
                        "has_error": true,
                        "status": error.response.status
                    })
                } else {
                    setError({
                        "has_error": true,
                        "status": 500
                    })
                }
            })
            .finally(() => {
                setLoading(false)
            })
    }

    useEffect(() => {
        setLoading(false)
    }, [])

    if (loading) {
        return (
            <LoadingPage clientThemeSettings={clientThemeSettings} />
        )
    }

    return (
            <S.PersonalDocumentConfirmationContainer>
                <p className="description-level4 gray no-border-container-fullwidth" style={{ textAlign: "justify", width: "100%" }}>
                    Confirme que você é o titular do documento abaixo, clicando no botão "Confirmar".
                </p>
                <PersonalDocumentSlider
                    documents={signBatchData.personal_documents}
                    clientThemeSettings={clientThemeSettings}
                />
                <div className="no-border-container-center" style={{marginTop: 0}}>
                    <Button style = {{width:120}}
                        onClick={onSubmit}
                        clientThemeSettings={clientThemeSettings}
                    >
                        CONFIRMAR
                    </Button>
                </div>
                {error.has_error &&
                    <ErrorPage
                        error={error}
                        redirectToLogin={() => setSignerBatchStep("login")}
                        resetError={() => setError(initialError)}
                        clientThemeSettings={clientThemeSettings}
                    />}
            </S.PersonalDocumentConfirmationContainer>
    )
}